import { HTMLAttributes } from 'react'

import { cn } from '@/lib/utils'

export type BurgerProps = HTMLAttributes<HTMLSpanElement> &
  Partial<{
    active: boolean
  }>

const Burger = ({ className, ...props }: BurgerProps) => {
  return (
    <button
      className={cn(
        'relative z-10',
        '-mr-[1.2rem] h-[3.2rem] w-[5.6rem] md:mr-0',
        'flex flex-col items-center justify-center gap-[0.3rem] transition-all duration-300 md:gap-spacing-2xs',
        'hover:gap-[0.3rem] hover:md:gap-[0.rem]',
        className
      )}
      {...props}
    >
      <span
        className={cn(
          'ease-in-out h-[0.2rem] w-[3.2rem] transform bg-current transition-all duration-300 md:w-full'
        )}
      />
      <span
        className={cn(
          'ease-in-out h-[0.2rem] w-[3.2rem] transform bg-current transition-all duration-300 md:w-full'
        )}
      />
    </button>
  )
}

export default Burger
